import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { LoaderContext } from "../../AuthContext/AuthContext";
import axios from 'axios';
import { BaseUrl } from '../../BaseUrl/BaseUrl';
const GanapatiVisarjanOrderDetails = () => {
    const { setLoader, convertTo12Hour } = useContext(LoaderContext);
    const location = useLocation()
    const navigate = useNavigate()
    const order = location?.state;
    const userID = JSON.parse(localStorage.getItem("userID"));
    const [subscriptionDetails, setSubscriptionDetails] = useState('')


    function formatToIndianCurrency(amount) {
        if (!amount) return "";

        const [integerPart, decimalPart] = amount.toString().split(".");

        // Format the integer part using Indian numbering system
        const formattedIntegerPart = integerPart.replace(
            // Match groups of 3 digits initially, then groups of 2 digits
            /(\d)(?=(\d\d)+\d$)/g,
            "$1,"
        );

        // Return the formatted value with the decimal part (if present)
        return decimalPart !== undefined
            ? `${formattedIntegerPart}.${decimalPart}`
            : formattedIntegerPart;
    }

    const handleProceedRemainingPujaPayment = async () => {
        // debugger;
        if (Math.round(order?.RemainingAmount) === 0) {
            alert("All the amount already paid");
            return;
        }


        // let minPayableAmount = modelRequestData.amountEntered
        //   ? modelRequestData.amountEntered
        //   : Math.round(grandTotal);

        const PlaceOrderResponse = await handleProceedRemainingPujaPayment(Math.round(order.RemainingAmount))
        console.log('PlaceOrderResponse', PlaceOrderResponse)
        setLoader(true)
        if (PlaceOrderResponse?.status === 1) {

            axios
                .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=GaneshVisarjan`, {
                    USER_ID: userID,

                    ORDER_ID: order?.PKSubPBookID,
                    TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
                    PAYMENT_STATUS: "Completed",
                    TRANSACTION_STATUS: "Success",
                    TRANSACTION_AMT: order.RemainingAmount,
                    REMAING_AMOUNT: 0,
                    PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
                })
                .then((res) => {

                    if (res.data.ResponseMessage === "Success.") {
                        setLoader(false)
                        navigate("/puja-kit-orders");
                    } else {
                        setLoader(false)
                        alert("Order placement failed, please try again.");
                    }
                });
        } else if (PlaceOrderResponse?.status === 0) {
            setLoader(false)
            alert('Order Failed !')
        }
    };

    const handleDownloadInvoice = (PB_ID) => {
        window.open(order?.InvoicePDFURL, "_blank");

    };
    return (
        <>
            <div className='mt-2'>
                {/* <div className="top">
                    <div
                        className="pujaDetails custom-flex"
                        style={{
                            display: "flex",
                            padding: "20px",
                            alignItems: "flex-start",
                            maxHeight: "80vh", // restrict overall height
                            overflow: "hidden", // prevent container from overflowing
                        }}
                    >


                        <div
                            className="right"
                            style={{
                                marginLeft: "20px",

                                maxHeight: "80vh",
                                paddingRight: "10px",
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h2
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: "20px",
                                        textTransform: "none",
                                        margin: 0,
                                    }}
                                >
                                    {order.Title} Ganapati Viasrjan
                                </h2>

                                {order.RemainingAmount > 0 && (
                                    <button className="careox-btn" onClick={handleProceedRemainingPujaPayment}>
                                        Proceed To Payment
                                    </button>
                                )}
                            </div>



                            <h4>
                                (₹){" "}

                                {formatToIndianCurrency(Math.round(Number(order.Price)))}
                            </h4>





                        </div>
                    </div>

                </div > */}
                <div className="container my-4">
                    <div className="row g-4">
                        {/* Puja Details */}
                        <div className="col-md-12">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <h5 className="card-title text-center fw-bold">
                                        Order Details
                                    </h5>
                                    <table className="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <td>Customer Name :</td>
                                                <td className=" fw-bold">{order.CustomerName}</td>
                                            </tr>
                                            <tr>
                                                <td>Mobile Number</td>
                                                {/* <td>{dayjs(order.BookingDate).format('DD/MM/YYYY')}</td> */}
                                                <td className=" fw-bold">{order.MobileNo}</td>
                                            </tr>

                                            <tr>
                                                <td>Booking Date</td>
                                                <td>
                                                    <td>{dayjs(order.BookingDate).format('DD/MM/YYYY')}</td>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Booking Time</td>
                                                <td className="fw-bold ">
                                                    {convertTo12Hour(order.Time)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Selected Services </td>
                                                <td>{order.ServiceNames}</td>
                                            </tr>
                                            <tr>
                                                <td>Accepted Status</td>
                                                <td>{order.AcceptStatus}</td>
                                            </tr>
                                            <tr>
                                                <td>Completion Status</td>
                                                <td>{order.AcceptStatus}</td>
                                            </tr>
                                            <tr>
                                                <td>Registration Date</td>
                                                <td>{dayjs(order.RegDate).format('DD/MM/YYYY')}</td>
                                            </tr>
                                            <tr>
                                                <td>Price (₹)</td>
                                                <td>
                                                    {formatToIndianCurrency(
                                                        Math.round(Number(order.Price))
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Paid Amount (₹) </td>
                                                <td>
                                                    {formatToIndianCurrency(Math.round(order.PaidAmount)) || 0}

                                                </td>
                                            </tr>
                                            {order.RemainingAmount > 0 && (
                                                <tr>
                                                    <td>Remaining Amount (₹) </td>
                                                    <td>
                                                        {formatToIndianCurrency(Math.round(order.RemainingAmount)) || 0}

                                                    </td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>




                        {/* Price Details */}
                        <div className="col-md-12 d-flex justify-content-center">
                            {/* <div className="card shadow-sm">
                                <div className="card-body">
                                    <h5 className="card-title text-center fw-bold">
                                        Price Details
                                    </h5>
                                    <table className="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <td> Price (₹)</td>
                                                <td className="text-end">
                                                    {formatToIndianCurrency(
                                                        Math.round(Number(order.Price))
                                                    )}
                                                </td>
                                            </tr>
                                            {order.CouponCodeAmount !== 0 ? (
                                                <tr>
                                                    <td>
                                                        Coupon Amount (₹)
                                                    </td>
                                                    <td className="text-end">
                                                        {order.CouponCodeAmount}
                                                    </td>
                                                </tr>
                                            ) : order.WalletAmount !== 0 ?
                                                <tr>
                                                    <td>
                                                        Wallet Amount (₹)
                                                    </td>
                                                    <td className="text-end">
                                                        {order.WalletAmount}
                                                    </td>
                                                </tr> : ''}


                                            <tr className="fw-bold">
                                                <td>Total Amount (₹)</td>
                                                <td className="text-end">
                                                    {formatToIndianCurrency(order.GrandTotal)}

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> */}
                            {order.InvoicePDFURL !== null && (
                                <a
                                    target="_blank"
                                    className="careox-btn mt-2"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDownloadInvoice(order.InvoicePDFURL)}
                                >
                                    Download Invoice
                                </a>

                            )}


                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default GanapatiVisarjanOrderDetails
